import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=2cdb201c&scoped=true&"
import script from "./confirmOrder.vue?vue&type=script&lang=js&"
export * from "./confirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=2cdb201c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb201c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cdb201c')) {
      api.createRecord('2cdb201c', component.options)
    } else {
      api.reload('2cdb201c', component.options)
    }
    module.hot.accept("./confirmOrder.vue?vue&type=template&id=2cdb201c&scoped=true&", function () {
      api.rerender('2cdb201c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/confirmOrder.vue"
export default component.exports